import { render, staticRenderFns } from "./AyudaParte1CultivoSmolt.vue?vue&type=template&id=34bf7b08&scoped=true"
import script from "./AyudaParte1CultivoSmolt.vue?vue&type=script&lang=js"
export * from "./AyudaParte1CultivoSmolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bf7b08",
  null
  
)

export default component.exports